const MAX_EXPORT_ROWS = 250000;

/**
 * Fetches data from getDrillDownData API with pagination support.
 * @param {object} baseRequestBody - The request body (nodeId, packageStatusMap, filters, etc.)
 * @param {function} apiCaller - Async function that takes a request object and returns a response
 * @param {object} options - Optional: { transformFn, startingIndex }
 * @returns {Promise<{results: Array, totalRowCount: number}>} - Accumulated results and count
 */
export async function paginatedFetch(baseRequestBody, apiCaller, options = {}) {
    const { transformFn = (r) => r, startingIndex = 0, maxRows = MAX_EXPORT_ROWS } = options;
    let paginationToken = null;
    let results = [];
    let totalRowCount = 0;

    do {
        const requestBody = { ...baseRequestBody, "startingIndex": paginationToken ? 0 : startingIndex };
        if (paginationToken) {
            requestBody.paginationToken = paginationToken;
        }

        const request = {
            resourcePath: "/os/getDrillDownData",
            httpMethod: "post",
            processName: "oculus",
            requestBody: requestBody
        };

        const response = await apiCaller(request);
        if (response.status === 200) {
            const batchResults = response.data.packageResultList || [];
            totalRowCount += batchResults.length;
            results.push.apply(results, transformFn(batchResults));
            paginationToken = response.data.paginationToken || null;

            if (batchResults.length === 0 || totalRowCount >= maxRows) {
                paginationToken = null;
            }
        } else {
            return { results: null, totalRowCount };
        }
    } while (paginationToken);

    return { results, totalRowCount };
}



// WEBPACK FOOTER //
// ./src/commons/api/PaginatedFetchUtil.js